import { getLink } from '../../../../utils/utils';

const content = {
	rus: (
		`
		<div style="text-align: justify;">
		
			<p class="mb-3 bold">Действующие лица:</p>

			<p class="mb-1">
				1. Артур
			</p>
			<p class="mb-1">
				2. Женщина с нижнего этажа
			</p>
			<p class="mb-1">
				3. Пётр
			</p>
			<p class="mb-3">
				4. Мужчина с верхнего этажа
			</p>

			<p class="italic mb-3">
				Комната Артура. 
				Посередине сцены – стол, над ним висит лампочка. 
				У стола стул, кресло. 
				Книжный шкаф с несколькими книгами. 
				На столе коробка с отвёрткой и большим железным крюком. 
				Телефон.
			</p>

			<p class="italic mb-3">
				(<span class="bold">Артур</span> входит, неся пластиковый пакет и складную лестницу. 
				Снимает пиджак. Внимательно оглядывается по сторонам)
			</p>

			<p class="mb-3">
				<span class="bold">Артур</span> Ну, вот и наступил решительный момент. (<span class="italic">Задумчиво осматривает сцену</span>) 
				Да. Можно сейчас всё и закончить. 
				Главное – всё должно быть сделано как надо. 
				Легко можно всё испортить одной маленькой ошибочкой… особенно если делаешь это первый раз. 
				Нужно действовать по плану… даже если это последний план в твоей жизни… Да где же этот список?!
			</p>

			<p class="italic mb-3">
				(Вынимает бумагу из пластикового пакета. Сверяет пункт за пунктом)
			</p>

			<p class="mb-3">
				Верёвка? 
				<span class="italic">(Вынимает электрический кабель. Разматывает его)</span> 
				Да… 
				Ну и что? 
				Ничего не было, кроме кабеля. 
				Досадно… этим вводится элемент импровизации в данную процедуру. 
				Зато в нём 13 ампер! 
				Лестница? 
				Да… 
				Прощальное письмо? 
				<span class="italic">(Вынимает незаклеенный конверт)</span> 
				Так, всё в порядке. 
				Как важно хорошее воспитание! 
				Мой учитель всегда говорил: «Делай всё как следует, даже если это последнее дело в твоей жизни». 
				Точно. 
				Если бы меня так не учили, я бы обязательно что-нибудь напутал в такой важной ситуации. 
				Нужно подготовиться основательно, продумать всё до последней детали. 
				Работать без метода – всё равно что плыть без руля и без ветрил. 
				Никакой ясности. 
				Вот я например – по этому списку я вижу всё, что мне нужно, и я спокоен. 
				Я знаю, где я и что мне делать. 
				Сколько людей могут сказать о себе то же самое?
			</p>

			<p class="mb-3">
				Ну-ка, ещё разок проверим. 
				Прощальное письмо… оно должно быть безупречным. 
				Одно слово, написанное не там и не так – и весь эффект пропадает. 
				В последние минуты жизни самое важное – стиль. 
				Как там говорится? 
				«Один грамм стиля важнее килограмма содержания». 
			</p>

			<p class="mb-3">
				<span class="italic">(Вынимает письмо из конверта, читает его)</span> 
				«Всем, кого это касается. 
				После долгих раздумий я решил положить конец всему. 
				Я больше не вижу причин продолжать мою бесполезную жизнь. 
				Всё, что я затеваю, кончается ничем. 
				Всё, что я делаю, начинается как ураган активности, как вулкан энтузиазма, бьющий из неисчерпаемого источника энергии. 
				Но всему суждено развеяться прахом, обратиться в нуль. 
				Никогда дело, начатое мною, не находило отклика в другой душе. 
				По словам Кьеркегора: «Чем яснее воспринимается непостижимый беспорядок человеческого существования, 
				тем более беспорядочным делается сам этот беспорядок, несмотря на то, что чем более глубок беспорядок, тем менее глубока ясность». 
				Короче: я должен 1 фунт 50 пенсов за клубную лотерею на прошлой неделе. 
				Я официально прошу будущего распорядителя моим имуществом заплатить эту сумму из средств, составляющих скидку в 3 фунта 40 пенсов, 
				положенную мне в результате взаиморасчётов за электрическую энергию. 
				Подписано: Артур Колебалов.» 
				Как по мне – отлично! 
				Кратко, чётко и по делу. 
				Тема раскрыта…
			</p>

			<p class="mb-3">
				<span class="italic">(Читает дальше)</span> 
				Минуточку! 
				А это что такое? 
				«После долгих раздумий я решил положить конец всему». 
				Нет, так не годится. 
				Я не могу положить конец всему. 
				Я кладу конец только самому себе. 
				После меня всё останется точно таким же, как оно есть сейчас. 
				Мусор останется в урне. 
				И те же люди будут ходить по улицам. 
				Исчезну только я один… <br/>
				Как это я не заметил такой ошибки? 
				Да, нельзя быть невнимательным даже на секунду. 
				Какое впечатление произведёт эта фраза? 
				Меня будут помнить только из-за того, что я не умел написать письмо без ошибок. 
				Ошибка в прощальном письме особенно заметна. 
				Нужно заменить… ну например… «Я решил положить конец моей жизни». 
				Да, это лучше… коротко и ясно. 
				Но с другой стороны… поправки в последнем письме выглядят –мммм - вносят в дело элемент импровизации, ставят под вопрос решимость… 
				Ну, ничего! 
				У меня уже нет времени, пусть остаётся так. 
				Пусть скажут: «Свои последние мысли он посвятил краткости… и стилю». 
				Бывают некрологи и похуже.
			</p>

			<p class="mb-3">
				<span class="italic">
					(Исправляет письмо, вкладывает его в конверт и ставит его на стол. 
					Оглядывает комнату. 
					Смотрит наверх на лампочку. 
					Отодвигает стол в сторону, ставит под лампу стремянку. 
					Смотрит на электрическую розетку у потолка, которая не видна зрителям)
				</span>
			</p>

			<p class="mb-5">
				Смотри-ка! 
				А тот паук всё ещё там! 
				Ещё в четверг я хотел его смести. 
				Или в субботу? 
				Пылесосом бы… 
				А это паук или насекомое? 
				У паука 6 ножек? 
				Или 8? 
				А паук это насекомое? 
				У насекомого есть головогрудь и брюшко… или пластрон и карапакс? 
				Всё забыл! 
				Надо посмотреть, пока не поздно. 
				<span class="italic">(Спускается по стремянке, берёт книгу из шкафа, читает)</span> 
				«Насекомое. 
				Существительное. 
				Беспозвоночное сегментированное существо, состоящее из головы, груди (или головогруди) и брюшка, с тремя парами грудных ног. 
				В переносном смысле означает незначительное лицо». 
				Ну вот, теперь я знаю. 
				<span class="italic">(задумывается)</span> 
				Что же я хотел сделать? 
				Ах да, пылесос.
				<span class="italic">
					(Уходит и возвращается с пылесосом. 
					Поднимается по стремянке, держа трубу пылесоса)
				</span>. 
				Ай-яй-яй, ну ты посмотри! 
				Не двигался с места неделю, а тут вдруг исчез молниеносно! 
				Ладно, потом поймаю… 
				Потом? 
				Да что это я говорю?
				<span class="italic">
					(Спускается по лесенке. 
					Уносит пылесос. 
					Поднимается по лесенке)
				</span>
				Надо проверить розетку. 
				От этого зависит всё.
				<span class="italic">
					(проверяет розетку на потолке, не видную зрителям. 
					Звонок в дверь. 
					<span class="bold">Артур</span> подпрыгивает. 
					Спускается, относит в сторону лестницу и подвигает стол под лампу. 
					Идёт к двери и возвращается с <span class="bold">женщиной с верхнего этажа</span>.)
				</span>
			</p>


			<p class="mb-1">
				<span class="bold">Артур:</span> Вы что-то хотели?
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> Извините. 
				Я не хотела вас побеспокоить. 
				Я вам помешала?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> ЭЭЭ… нннет… 
				Вы что-то хотели?
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> Я хочу отдать вам сдачу с денег, которые вы дали мне, чтобы заплатить за молоко. 
				Я заплатила вчера. 
				Осталось 15 копеек сдачи после оплаты двух литров прекрасного базарного молока. 
				Ведь вы два литра просили, я не ошиблась? 
				Легко ошибиться, если ты занят с утра до вечера. 
				А я вот всегда стараюсь делать всё безупречно до малейшей детали. 
				Я – само совершенство – так говорит моя подруга. 
				«Ты – само совершенство», - говорит она. 
				Я должна, обязательно должна ставить обувь под вешалкой по линейке. 
				Я всегда выношу помойное ведро ежедневно. 
				Ведь это очень важно, сразу выносить мусор, вы согласны?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> <span class="italic">(Нервно)</span> Нуу… да.
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> Вот вам ваши деньги.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Спасибо.
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> <span class="italic">(Останавливаясь у двери)</span> На следующей неделе тоже заплатить вам за молоко?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Нет, спасибо. 
				На следующей неделе мне не нужно будет молоко.
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> Вы уезжаете? 
				В отпуск?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Нет… Да… Нет. 
				Ну… Ладно, возьмите для меня немного молока.
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> Как всегда? 
				Лучшего базарного?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Ну… да. 
				Лучшего базарного.
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> Хорошо. 
				Видите ли, я считаю, что всегда нужно быть скрупулёзной. 
				Моя подруга всегда говорит мне: «Ты слишком скрупулёзна. 
				Я никогда не встречала человека более скрупулёзного, чем ты», - так она мне говорит.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> <span class="italic">(С трудом сдерживаясь)</span> Ну да, да, вы правы. 
				Можно быть очень скрупулёзным, я вас понимаю. 
				А теперь, будьте добры… у меня много дел. 
				Мне нужно срочно закончить одну работу.
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> Я всегда говорю, что если работа не срочная, то с ней можно тянуть и тянуть. 
				Очень важно поставить определённый срок. 
				Без такого срока можно тянуть и тянуть, надеясь, что всё как-то кончится само собой. 
				А я вот думаю, что очень плохо тянуть и тянуть, надеясь, что всё как-то кончится само собой. 
				Вы согласны?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Да, конечно. 
				Именно так я и думаю. 
				А теперь… как я сказал, у меня очень важное дело.
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> Понятно-понятно. 
				Я не хочу вам мешать. 
				Успехов в вашем деле! До свидания!
			</p>

			<p class="mb-5">
				<span class="bold">Артур:</span> До свидания!
			</p>


			<p class="mb-1">
				<span class="italic">(<span class="bold">Женщина</span> уходит. 
				<span class="bold">Артур</span> отставляет стол и ставит лестницу под лампу. 
				Поднимается, держа кабель)</span>
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Нет, вы только посмотрите! 
				Она держится только на двух шурупчиках в гипсе! 
				Это и канарейку не выдержит! 
				В решающий момент, когда понадобится, чтобы всё было в порядке, что мы найдём? 
				Всё рухнет! 
				Вот современное общество! 
				Понятие хорошо сделанной работы ушло в прошлое! 
				Сейчас нельзя ни от кого зависеть, всё нужно делать самому. 
				Нужно закрепить что-нибудь более прочное. 
				Проверить гипс. 
				Нужна отвёртка.<br/>
				<span class="italic">
					(Спускается, ищет в коробке, находит отвёртку. 
					Поднимается по лесенке. 
					Звонок в дверь)
				</span>
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Кто там? <span class="italic">(Громче)</span> Кто там?
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> <span class="italic">(Из-за двери)</span> Это я, Пётр.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Я сейчас очень занят. 
				А что нужно?
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> Завтра я уезжаю. 
				Я хочу отдать тебе деньги за прошлую неделю.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> <span class="italic">(Колеблется, затем спускается, выходит и возвращается с <span class="bold">Петром</span>)</span>
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> <span class="italic">(Глядя на стремянку)</span> Что случилось? 
				У тебя ремонт?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Нет, просто генеральная уборка. 
				Хочу пропылесосить потолок. 
				<span class="italic">(Убирает стремянку, вновь ставит стол под лампу)</span>
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> Я должен тебе 3 фунта 50 за прошлую неделю.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> 3 фунта 95, если я не ошибаюсь.
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> Нет-нет, разве ты не помнишь? 
				Мы договорились, что я плачу за яблочный пирог со взбитым кремом и за капучино. 
				Это стоило 3 фунта 50, но у меня тогда не было с собой денег.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Точно. 
				Так и было сначала. 
				Но потом официантка сказала, что яблочный пирог со взбитым кремом кончился, и мы заказали банановый десерт с вишнями, 
				посыпанный тёртым шоколадом, который стоил на 45 пенсов дороже.
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> О да-да, ты прав. 
				Извини, я забыл об этом. 
				Итак, я должен тебе 3 фунта 95.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Но не важно. 
				Знаешь, как раз сейчас…
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> <span class="italic">(Перебивает его)</span> Нет-нет, я настаиваю на этом. 
				Долги надо платить. 
				Вот, 3-95.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Спасибо. 
				А сейчас, как я уже сказал, я очень занят, Пётр. 
				Будь так добр…
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> <span class="italic">(Перебивает его)</span> В самом деле? 
				И что это? 
				Новый проект?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Ну… да, можно и так это представить. 
				Но закончить нужно к определённому сроку, Пётр. 
				Я должен уделить этому всё моё внимание. 
				Так что, пожалуйста…
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> <span class="italic">(Перебивает его)</span> 
				Я не хочу тебя перебивать, Артур, ты знаешь, как я тебя уважаю, но вот это в тебе самое главное! 
				Вот что я ценю! 
				Ты всегда занимаешься чем-то важным, и твои проекты всегда на грани человеческих сил! 
				Никогда нельзя предсказать, чем ты будешь заниматься в следующий момент, и это великолепно! 
				Ты готов исследовать идею, независимо от того, куда она приведёт. 
				Это черта свободного мыслителя, творца, гения! 
				Я восхищаюсь тобой! 
				Кстати, я говорил тебе о моей новой идее? 
				Построить крышу над городом, чтобы защитить его от ядерных бомб и ракет?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Ну Пётр, может быть, в другой раз? 
				Я в самом деле сейчас ужасно занят…
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> <span class="italic">(Не обращая на него внимания)</span> Я знаю, что ты скажешь. 
				Ты скажешь, что сейчас антитеррористической деятельности уделяется большое внимание, этим занимаются специальные службы, 
				и не нам туда соваться с нашими идеями. 
				Но ведь у каждого есть гражданский долг и гражданская совесть, и она повелевает мне… 
				Как сознательный патриот я должен сделать всё для защиты своего родного города. 
				Вот смотри, нужно построить бетонную крышу надо всем городом, такой конус высотой 300 метров, и чтоб вершина его была над самым центром. 
				Тогда если что-то упадёт на него сверху, оно обязательно скатится по наклонной плоскости и… угадай, что дальше? 
				А вокруг мы выроем огромную канаву! 
				И всё, что скатится сверху, попадёт в эту канаву, и пусть там взрывается, сколько угодно! 
				Здорово, да? 
				А знаешь, как мне пришла в голову эта идея? 
				Я просто смотрел на капли дождя, которые скатываются по крыше. 
				Представляешь, миллионы людей видели эту самую обыкновенную вещь, но никто не догадался…
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Да-да, прекрасная идея. 
				Это в самом деле очень важно, Петр. 
				Но может, поговорим об этом в другой раз? 
				Видишь ли, я…
			</p>

			<p class="mb-1">
				<span class="bold">Петр:</span> <span class="italic">(Перебивает его)</span> Артур, ты не представляешь, до чего дошло дело. 
				Ты даже не можешь себе вообразить, 
				какую непробиваемую стену человеческой глупости возводят официальные инстанции между собой и простыми людьми с их скромными, но разумными мнениями. 
				Слушай! 
				<span class="italic">(Вынимает из кармана письмо)</span> Вот какое письмо пришло мне из Министерства обороны. 
				<span class="italic">(Читает)</span> <br/>
				«Благодарим за ваше письмо с предложением возвести железобетонную крышу над нашим городом в качестве защиты от бомб и ракет. 
				Разумеется, вы представляете себе, что реализация этой идеи вызовет несколько практических затруднений. 
				Вот некоторые из них. 
				Во-первых, выкуп земельных участков у их нынешних владельцев для установки опор с целью поддержания железобетонного конуса диаметром 
				32 километра и площадью 800 квадратных километров на высоте трехсот метров над поверхностью земли. 
				Принудительный выкуп этих участков несомненно вызовет длительные судебные процессы. 
				Также необходимо будет получить разрешение от Министерства городского планирования в связи с перепланировкой некоторых районов. 
				Кроме того, встаёт проблема обеспечения светом населения, вынужденного жить под бетонной крышкой, а это без малого 10 миллионов человек. 
				Ведь несомненно, такая обширная крыша, поднятая над земной поверхностью всего на 300 метров, неизбежно почти полностью закроет доступ солнечного света в город. 
				Далее, ров по периметру города будет достигать длины около 100 километров, что означает выемку грунта в количестве более миллиона кубических метров. 
				В связи со всем вышеизложенным, мы пересылаем Ваше предложение в Министерство городского планирования для дальнейшего рассмотрения».<br/>
				Ну, и что ты об этом думаешь? 
				Они просто отфутболивают моё предложение, чтобы дождаться, пока о нём все не забудут. 
				Всегда одна и та же история! 
				Но надо бороться: бороться против этой рутины, этого тупого упорного непонимания. 
				Как же создавать что-то новое, когда вот такие люди специально сидят, чтобы давить, душить любую новую идею, затоптать все проростки живой и смелой мысли?! 
				Как бороться, а? 
				Я спрашиваю!! 
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> <span class="italic">(На протяжении всего монолога он всё более и более раздражается)</span> 
				Да, Пётр, я так хорошо тебя понимаю. 
				Решать проблемы на практике гораздо сложнее, чем придумывать их. 
				Я вот, например, в данный момент озабочен решением проблемы, как подвесить груз в 64 килограмма на шнуре от лампы, 
				который держится на двух шурупчиках, ввинченных в гипс.
			</p>

			<p class="mb-5">
				<span class="bold">Петр:</span> Ну, Артур, к сожалению, я должен признаться, что в решении данной проблемы я не компетентен. 
				В школе я плохо успевал по физике, и в разделе «электричество», и в разделе «механика». 
				Я вообще никогда не мог сосредоточиться на мелочах, таких как цифры, количества, объёмы… я до сих пор плохо считаю… 
				Так что придётся тебе самому решать эту проблему. 
				Единственное, что я могу тебе посоветовать – найди здоровенный крюк. 
				Мне кажется, что для поддержания такого веса нужен мощный железный крюк или, ещё лучше, стальной болт с гайкой. 
				Ну, в любом случае, успеха тебе! Пока! <span class="italic">(<span class="bold">Пётр</span> уходит)</span>
			</p>


			<p class="mb-1">
				<span class="bold">Артур:</span> 
				<span class="italic">
					(Берёт отвёртку. 
					Поднимается на лесенку)
				</span> 
				Ну… попробуем. 
				Осторожнее с проводами… я ведь не хочу, чтобы меня убило электрическим током. 
				Ага… да… так. 
				<span class="italic">(Падают несколько кусочков гипса)</span>. 
				Хорошо… а теперь мне нужен крюк. <br/>
				<span class="italic">
					(Спускается. 
					Ищет крюк. 
					Звонят в дверь. 
					<span class="bold">Артур</span> не обращает внимания. 
					Находит крюк. 
					Ещё раз звонят. 
					<span class="bold">Артур</span> не обращает внимания. 
					Поднимается по лесенке. 
					Сыплется гипс. 
					В дверь стучат и звонят. 
					<span class="bold">Артур</span> уже не может не обращать внимания. 
					Спускается. 
					Выходит. 
					Возвращается с <span class="bold">мужчиной с нижнего этажа:</span>. 
					<span class="bold">Мужчина</span> одет в строгий костюм с галстуком, держится прямо с армейской выправкой, голос начальственный, в руках портфель. 
					Видно, что он привык командовать).
				</span>
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> В чём дело? У меня нет времени разговаривать с вами.
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> 
				Только что было приказано всем покинуть дом. 
				Все находящиеся в здании должны быть эвакуированы. 
				Немедленно покиньте комнату. 
				У вас нет времени даже взять личные вещи.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> В чём дело? Что случилось?
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Не разговаривать! 
				Немедленно покинуть дом! Марш!
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Да в чём же дело, чёрт возьми?
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Только что произошло землетрясение. 
				Семь баллов по шкале Рихтера.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Где?
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Здесь.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> <span class="italic">(Оглядывается)</span> Здесь всё в порядке. 
				Пока что всё стоит на месте.
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Разумеется. 
				Этот дом – единственное уцелевшее здание; всё остальное разрушено. 
				Именно поэтому необходимо немедленно покинуть помещение. 
				Оно может рухнуть в любую секунду.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> А почему не слышно шума? 
				Если бы было землетрясение, я бы что-нибудь услышал или почувствовал.
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Не обязательно. 
				Возможно, ваше внимание было отвлечено чем-то другим.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> <span class="italic">(Выходит посмотреть. 
				Возвращается)</span> На улице всё спокойно. 
				Даже центральный офис Главной Компании страхования от несчастных случаев стоит как ни в чём не бывало.
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Не спорьте со мной! 
				В случае необходимости я могу позвать на помощь, и вас силой выведут из дома. 
				В критический момент сознательный гражданин должен отказаться от собственных прав ради безопасности всего народа. 
				В силу прав и обязанностей, которые я получил согласно параграфу 6 Парламентского Акта №154, я официально приказываю вам немедленно покинуть помещение.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Да иди ты…
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Вы не имеете права оскорблять меня! 
				Вы что, не понимаете, что за пределами этой квартиры всё разрушено до основания?! 
				Всё распалось, везде хаос, а вы не хотите этого видеть.
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Это только в этой комнате всё распалось в хаос… Идите отсюда…
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Хорошо. 
				Вы отказываетесь идти. 
				Тогда у меня не остаётся другого выхода. 
				<span class="italic">(Вынимает из кармана свисток и свистит)</span> 
				Мы быстро решим вашу проблему, гражданин. 
				Я не имею права рисковать безопасностью всего народа из-за упрямства отдельного индивида. 
				Не удивительно, что народ всё более деградирует, если среди нас находятся такие элементы, как вы. 
				Люди, которые неспособны в критическую минуту подчиняться здравому смыслу; люди, которые в годину испытаний, 
				когда весь народ находится на грани уничтожения, могут утверждать, что всё в порядке, и спокойно красить потолок. 
				Вы что, не знаете, что вы должны покинуть дом и выйти на улицу, как только прозвучал сигнал тревоги?
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Сигнал тревоги?
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Ну да, предупреждающий сигнал. 
				«Длительное звучание сирены с переменной высотой».
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Я ничего не слышал.
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> Это ваша вина. 
				Каждый обязан быть бдительным и всегда готовым к любым опасностям. 
				Официальная инструкция №15, параграф 2 из Устава Гражданской обороны гласит: «При сигнале тревоги каждый обязан…»
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> <span class="italic">(Теряет терпение и яростно кричит)</span> Довольно! Хватит! 
				Я больше не могу! Уйдите!
			</p>

			<p class="mb-1">
				<span class="italic">(<span class="bold">Артур</span> хватает <span class="bold">мужчину</span> и толкает его за кулисы)</span>
			</p>

			<p class="mb-5">
				<span class="bold">Мужчина:</span> <span class="italic">(Размахивает руками и кричит)</span> 
				Это вам так не пройдёт! Я пожалуюсь! Самому… 
				<span class="italic">(Уходит, свистя в свисток)</span>
			</p>




			<p class="mb-1">
				<span class="bold">Артур:</span> <span class="italic">(Бессильно падает в кресло)</span> 
				Боже мой! Хаос! Все сошли с ума! А так хорошо всё начиналось. 
				<span class="italic">(Пауза. 
				Внезапно ему приходит в голову идея. 
				Он вскакивает и кричит)</span> Дверь! Надо закрыть дверь! Как я об этом раньше не подумал? 
				<span class="italic">
					(Выходит закрыть дверь. 
					Возвращается)
				</span> <br/>
				Да, а что же это я хотел сделать? 
				А, надо проверить длину верёвки. <br/>
				<span class="italic">
					(Сдвигает в сторону лестницу, придвигает стол под крюк. 
					Делает из кабеля петлю. 
					Примеряет её на шею. 
					Запрыгивает на стол. 
					Привязывает кабель наверху, так, что петля свисает над столом)
				</span>
			</p>

			<p class="mb-5">
				<span class="bold">Артур:</span> Ну, кажется, теперь всё в порядке. 
				Наконец-то. 
				Хотя… хотя… минутку… если дверь будет закрыта, никто не сможет сюда войти. 
				Нет, так не годится. 
				А вдруг пройдёт неделя, пока они догадаются? 
				Или ещё больше? 
				Представляю, труп, провисевший неделю… Брр! 
				Не хочу, чтобы меня запомнили таким. 
				Нет, надо открыть дверь! <br/>
				<span class="italic">
					(Выходит, открывает дверь. 
					Возвращается, залазит на стол. 
					Надевает петлю на шею. 
					Становится на край стола)
				</span> <br/>
				Решайся!! Прыгай! <br/>
				<span class="italic">
					(Прыгает со стола. 
					Падает на пол. 
					Крюк вырывается из потолка и падает на него вместе с большим куском гипса. 
					Пока Артур растерянно сидит, весь запорошенный гипсом, <span class="bold">женщина с верхнего этажа</span> пронзительно кричит за кулисами. 
					<span class="bold">Женщина</span> вбегает, задыхаясь от испуга. 
					Артур в продолжение всей последующей сцены остаётся сидеть на полу)
				</span>
			</p>




			<p class="mb-1">
				<span class="bold">Женщина:</span> 
				Ах, какой ужас! Какой ужас! Какой кошмар! 
				В жизни не видела ничего более ужасного! Я в шоке. 
				Что делать? Зовите полицию! Полиция!
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> <span class="italic">(Смущённо)</span> 
				Да я так… Ничего…
			</p>

			<p class="mb-1">
				<span class="italic">(Входят <span class="bold">Пётр</span> и <span class="bold">мужчина с нижнего этажа</span>)</span>
			</p>

			<p class="mb-1">
				<span class="bold">Пётр:</span> Я должен вызвать полицию. 
				Позволь твой телефон. 
				<span class="italic">(Подходит к телефону, набирает номер и говорит, пока происходит следующий диалог)</span>
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> 
				А нужно ли обязательно вызывать полицию? Я только… эээ… упал… со стола.
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> 
				Там, в парадной… общий балкон… 
				Мужчина из соседней квартиры… 
				Он повесился на перилах балкона. 
				Я только спускалась по лестнице, чтобы пойти в кино с моей подругой. 
				И вот я вижу верёвку, привязанную к перилам. 
				Я смотрю вниз… и он там висит! 
				Я вижу только верх его головы. 
				Но мне этого хватило. 
				Представляете, верх головы! Верх головы!
			</p>

			<p class="mb-1">
				<span class="bold">Артур:</span> Повесился на перилах балкона!
			</p>

			<p class="mb-1">
				<span class="bold">Женщина:</span> Ну, я опаздываю в кино. 
				Сегодня показывают хороший фильм: «Душитель в Красном доме». 
				Моя подруга говорит, я всегда выбираю хорошие фильмы. 
				<span class="italic">(Уходит)</span>
			</p>

			<p class="mb-1">
				<span class="bold">Мужчина:</span> 
				Ну, это уже слишком! 
				Он специально повесился, чтобы подмочить репутацию дома! 
				Но я этого не допущу! 
				У меня связи в органах! 
				Мы всех выведем на чистую воду! 
				<span class="italic">(Уходит решительным шагом)</span>
			</p>

			<p class="mb-1">
				<span class="bold">Пётр:</span> <span class="italic">(Возвращается от телефона)</span> 
				Подумать только! 
				Повеситься на перилах балкона! 
				Люди совершенно перестали считаться друг с другом. 
				Думают только о себе. 
				Ему было трудно? 
				А кому легко? 
				У него проблемы? 
				У всех проблемы! 
				Но что будет, если каждый начнёт вешаться? 
				Об этом он наверняка не подумал. 
				Люди вообще перестали думать. 
				<span class="italic">(Смотрит на Артура)</span> <br/>
				А что это с тобой? 
				Упал со стола? 
				Нужно быть осторожней, так и убиться недолго. 
				«Смотри, прежде, чем прыгать!» - вот мой лозунг. 
				Тебе помочь? Нет? Ну ладно, я пошёл. Пока! 
				<span class="italic">(Уходит)</span>
			</p>

			<p class="mb-4">
				<span class="bold">Артур:</span> 
				…на перилах балкона! 
				Как я об этом не подумал? 
				Но не повторять же! 
				Главное – стиль! 
				А повторение – дурной стиль. 
				Нельзя допускать пошлости и дурного стиля. 
				А как хорошо всё начиналось!
			</p>

			<p class="bold text-center text-uppercase">Конец</p>
		</div>
		`
	)
}

const itemName = {
	rus: `Смотри, прежде чем прыгать`
}

const itemAuthor = {
	rus: `Пьеса Гарольда Брауна (1925 - 2004)<br/>
		Перевод на русский язык Татьяны Аудерской
	`
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus + '!',
		itemContent: content.rus,
		itemAuthor: itemAuthor.rus
	}
}

export default item;